module.exports = __webpack_public_path__ + "static/media/foto_stanza_albergo3_comp.16103870.jpg";